export const phoneNumbersFormat = {
  Croatia: '+... ... ... ...',
  Chile: '+.. ... ... ...',
  Cuba: '+.. ... ... ...',
  Greece: '+.. ... ... ... .',
  Portugal: '+... ... ... ...',
  Bulgaria: '+... ... ... ...',
  Germany: '+.. .... .......',
  Estonia: '+... .... ...',
  Netherlands: '+.. .. .......',
  Albania: '+... ... ... ...',
  Andorra: '+... ... ...',
  Austria: '+.. ... ... ... .',
  'Bosnia and Herzegovina': '+... ... ... ..',
  Georgia: '+... ... ... ...',
  Hungary: '+.. ... ... ...',
  Kosovo: '+... ... ... ..',
  Liechtenstein: '+... ... ... ...',
  Luxembourg: '+... ... ... ...',
  Lithuania: '+... ... ... ..',
  Malta: '+... ... ... ..',
  Monaco: '+... ... ... ...',
  Montenegro: '+... ... ... ..',
  Romania: '+.. ... ... ...',
  'San Marino': '+... ... ... ..',
  Serbia: '+... ... ... ...',
  Slovakia: '+... ... ... ...',
  Slovenia: '+... ... ... ..',
  Italy: '+.. ... ......',
};
